/**
 * Enumerates the possible reasons for attempting to reconnect to a server-sent events (SSE) stream.
 *
 * @remarks
 * This enum is used to specify the cause of a reconnection attempt within the SSE context provider.
 *
 * @enum
 * @property {string} Error - Reconnection due to an error in the SSE connection.
 * @property {string} HeartbeatTimeout - Reconnection triggered by a missed heartbeat signal.
 * @property {string} Initial - Initial connection attempt.
 * @property {string} LeadershipGained - Reconnection after gaining leadership in a distributed system.
 * @property {string} LeadershipLost - Reconnection after losing leadership in a distributed system.
 * @property {string} Manual - Manual reconnection initiated by the user or application.
 * @property {string} ProviderMounted - Reconnection triggered when the provider component is mounted.
 * @property {string} Resync - Reconnection to resynchronize state with the server.
 * @property {string} Unknown - Reconnection for an unspecified or unknown reason.
 */
export enum ReconnectReason {
  Error = 'error',
  HeartbeatTimeout = 'heartbeat-timeout',
  Initial = 'initial',
  LeadershipGained = 'leadership-gained',
  LeadershipLost = 'leadership-lost',
  Manual = 'manual',
  ProviderMounted = 'provider-mounted',
  Resync = 'resync',
  Unknown = 'unknown',
}
